<span> {{ data.message | translate }} {{ data.extraMessage | translate }}</span>
